module.exports = __webpack_public_path__ + "img/oddnary-variation-7.a8e3952d.jpg";